import { useEffect } from 'react'
import { CircleCheck } from 'lucide-react'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'

type SavedDialogProps = {
  open: boolean
  onOpenChange: (open: boolean) => void
  title?: string
  description?: string
}

export default function SavedDialog({
  open,
  onOpenChange,
  title = 'Saved',
  description = 'Your changes have been saved.',
}: SavedDialogProps) {
  useEffect(() => {
    if (!open) return
    const timeout = setTimeout(() => onOpenChange(false), 2000)
    return () => clearTimeout(timeout)
  }, [open, onOpenChange])

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        showCloseButton={false}
        className="top-4 translate-y-0 bg-white data-open:slide-in-from-top-2"
      >
        <div className="flex items-start gap-3">
          <CircleCheck className="mt-0.5 size-5 shrink-0 text-green-600" />
          <DialogHeader className="gap-1">
            <DialogTitle>{title}</DialogTitle>
            <DialogDescription>{description}</DialogDescription>
          </DialogHeader>
        </div>
      </DialogContent>
    </Dialog>
  )
}
